import { render, staticRenderFns } from "./UserConfirmBookingModal.vue?vue&type=template&id=f96cbaa2&scoped=true&"
import script from "./UserConfirmBookingModal.vue?vue&type=script&lang=ts&"
export * from "./UserConfirmBookingModal.vue?vue&type=script&lang=ts&"
import style0 from "./UserConfirmBookingModal.vue?vue&type=style&index=0&id=f96cbaa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96cbaa2",
  null
  
)

export default component.exports